import React from "react";
import Slider from "react-slick";
import { Link } from "react-router-dom";
import { HEADER } from "../../utils/constant";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const SlickSlider = ({ header, slides = [], swiperConfig = {}, className = "" }) => {
  const validSlides = slides.filter((s) => s !== null);
  const settings = {
    dots: false,
    arrows: false,
    infinite: validSlides.length > 2,
    slidesToShow: 2,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    speed: 500,
    pauseOnHover: false,
    pauseOnFocus: false,
    ...swiperConfig,
  };

  return (
    <section className={`slider ${className}`}>
      <div className="slider-header">
        <h4>
          {HEADER === header ? "Start Earning Points" : "Rewards"}
        </h4>
        {HEADER === header ? "" : <Link to="/reward">View All Rewards</Link>}
      </div>

      <Slider {...settings}>
        {slides
          .filter((slide) => slide !== null)
          .map((slide, index) => (
            <div key={index} className="slick-slide">
              {slide}
            </div>
          ))}
      </Slider>
    </section>
  );
};

export default SlickSlider;
